import { PaymentRequestType } from '@mews-commander/data-access';
import { ProcessPaymentType } from './ProcessPaymentType';

export const DEFAULT_PROCESS_PAYMENT_TYPES = [
    ProcessPaymentType.GatewayPayment,
    ProcessPaymentType.MewsTerminalPayment,
    ProcessPaymentType.PaymentRequest,
    ProcessPaymentType.CashPayment,
    ProcessPaymentType.ExternalCardPayment,
    ProcessPaymentType.ExternalPayment,
];

export const CHARGE_GUEST_PROCESS_PAYMENT_TYPES = [
    ProcessPaymentType.GatewayPayment,
    ProcessPaymentType.MewsTerminalPayment,
    ProcessPaymentType.PaymentRequest,
    ProcessPaymentType.GatewayCardPreauth,
    ProcessPaymentType.MewsTerminalPreauth,
    ProcessPaymentType.TokenizeCard,
];
export const EXTERNAL_PROCESS_PAYMENT_TYPES = [
    ProcessPaymentType.CashPayment,
    ProcessPaymentType.ExternalCardPayment,
    ProcessPaymentType.ExternalPayment,
    ProcessPaymentType.ExternalCardPreauth,
    ProcessPaymentType.RecordCard,
];

export const DEFAULT_PAYMENT_REQUEST_TYPE_OPTIONS = [
    PaymentRequestType.Payment,
    PaymentRequestType.Preauthorization,
    PaymentRequestType.PaymentMethod,
];

export const DISABLED_PROCESS_PAYMENT_TYPES = [ProcessPaymentType.GatewayPayment, ProcessPaymentType.TokenizeCard];

export const DEFAULT_PREAUTHORIZATION_EXPIRATION_DAYS = 7;
